export const ColWidths = {
  xSmall: 80,
  small: 100,
  normal: 130,
  medium: 180,
  large: 200,
  xLarge: 250,
};
